import { GtmTrackingType } from '../constants';

class GtmProductDetailViewDelegator {
	constructor() {
		this.type = GtmTrackingType.PRODUCT_DETAIL_VIEW;
	}

	getTrackingData() {
		const dataLayerProps = window.dataLayer[0];

		if (this.shouldTrackProductDetailView(dataLayerProps)) {
			const { skuInfo } = dataLayerProps;

			return {
				event: 'productDetailView',
				ecommerce: {
					detail: {
						products: [
							{
								name: skuInfo.skuName || 'undefined',
								id: skuInfo.skuID || 'undefined',
								price:
									Object.prototype.hasOwnProperty.call(skuInfo, 'price') &&
									!!skuInfo.price.length
										? skuInfo.price[0].skuPriceexVAT || 'undefined'
										: 'undefined',
								category: skuInfo.skuHierarchy || 'undefined',
								position: 1,
								brand: 'undefined',
								variant: 'undefined',
								dimension27: skuInfo.stockLevelStatusGa,
								dimension19:
									Object.prototype.hasOwnProperty.call(skuInfo, 'price') &&
									!!skuInfo.price.length
										? skuInfo.price[0].pricingType || 'undefined'
										: 'undefined',
								item_category: skuInfo.skuItemCategory || 'undefined',
								item_category2: skuInfo.skuItemCategory2 || 'undefined',
								item_category3: skuInfo.skuItemCategory3 || 'undefined',
							},
						],
					},
				},
			};
		}
	}

	shouldTrackProductDetailView(dataLayerProps) {
		const isProductDetailPage =
			dataLayerProps.navigation &&
			dataLayerProps.navigation.pageType === 'product';

		return (
			isProductDetailPage &&
			Object.prototype.hasOwnProperty.call(dataLayerProps, 'skuInfo')
		);
	}
}

const GtmProductDetailViewDelegatorInstance =
	new GtmProductDetailViewDelegator();
export default GtmProductDetailViewDelegatorInstance;

// for test purpose only
export const GtmProductDetailViewDelegatorClass = GtmProductDetailViewDelegator;
